import { I_QREditorFormTemplate } from "@/data/types/pages";
import { getRuleErrorMessage } from "@/utils/formHelper";
import { qrNameValidation } from "./shared";
import { TFunction } from "i18next";

export const qrSmsValidation = (data: I_QREditorFormTemplate, t: TFunction) => {
  return [
    qrNameValidation(t),
    {
      name: "phoneNumber",
      rules: {
        required: {
          value: true,
          message: getRuleErrorMessage("phoneNumber", "required", data),
        },
        maxLength: {
          value: 70,
          message: getRuleErrorMessage("phoneNumber", "maxLength", data),
        },
      },
    },
    {
      name: "message",
      rules: {
        required: {
          value: true,
          message: getRuleErrorMessage("message", "required", data),
        },
        maxLength: {
          value: 300,
          message: getRuleErrorMessage("message", "maxLength", data),
        },
        pattern: {
          value:
            /^[^\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F1E6}-\u{1F1FF}]*$/u,
          message: getRuleErrorMessage("message", "pattern", data),
        },
      },
    },
  ];
};
